export default {
	title: 'Terminal Self-Diagnosis',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	noData: {
		title: 'No Terminal Self-Diagnosis Data',
		description: 'No terminal self-diagnosis data found'
	},
	actions: {
		add: 'Add',
		diagnose: 'Diagnose',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		diagnosisSuccess: 'Diagnosis completed',
		missingTerminalId: 'Terminal ID is missing; diagnosis cannot be started',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		projNo: 'Project',
		typeId: 'Terminal Type',
		maker: 'Manufacturer',
		transferProtocol: 'Communication Protocol',
		model: 'Model',
		number: 'Terminal Number',
		upMode: 'Up Mode',
		downMode: 'Down Mode',
		placeholder: {
			projNo: 'Please select project',
			typeId: 'Please select terminal type',
			maker: 'Please enter manufacturer',
			transferProtocol: 'Please select communication protocol',
			model: 'Please enter model',
			number: 'Please enter terminal number',
			upMode: 'Please select up mode',
			downMode: 'Please select down mode'
		}
	},
	table: {
		number: 'Terminal Number',
		projNo: 'Project No',
		model: 'Model',
		downMode: 'Down Mode',
		pingTime: 'Ping Time',
		typeId: 'Terminal Type',
		transferProtocol: 'Communication Protocol',
		remark: 'Remark',
		warnStatus: 'Terminal Status',
		notDetected: 'Not Detected',
		noConnection: 'Unable to Establish Connection',
		maker: 'Manufacturer'
	},
	detail: {
		normal: 'Normal',
		abnormal: 'Abnormal',
		sdram: 'SDRAM',
		rtc: 'RTC',
		flash: 'Flash',
		uart: 'UART',
		exflash: 'External Flash',
		sensor: 'Sensor Status',
		connected: 'Connected',
		disconnected: 'Disconnected'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		close: 'Close',
		selfDiagnosisDetail: 'Self-Diagnosis Details'
	}
}
